import React from 'react';
import { useStyletron } from 'baseui';
import { BooleanColumn, NumericalColumn, CustomColumn, StringColumn, CategoricalColumn } from 'baseui/data-table';
import _find from 'lodash/find';

import { CustomDateColumn, EMPTY_ARRAY, EMPTY_STRING } from 'commons-ui';
import { LANG_OPTIONS } from '../../utils/constants';

export const COL_NAMES = {
	code: 'code',
	label: 'label',
	type: 'type',
	location: 'location',
	ctaType: 'ctaType',
	ctaValue: 'ctaValue',
	ctaParamsGameName: 'ctaParamsGameName',
	imageRatio: 'imageRatio',
	imageUrl: 'imageUrl',
	isActive: 'isActive',
	language: 'language',
	sortOrder: 'sortOrder',
	expiresAt: 'expiresAt',
	userSpecificSegmentsList: 'userSpecificSegmentsList',
	segmentInstruction: 'segmentInstruction',
	maxAppVersionSupported: 'maxAppVersionSupported',
	minAppVersionSupported: 'minAppVersionSupported',
	removedForBlockedUser: 'removedForBlockedUser'
};

export const columnConfigs = [
	CategoricalColumn({
		title: 'Code',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.code]
	}),
	StringColumn({
		title: 'Label',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.label]
	}),
	CategoricalColumn({
		title: 'Type',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.type]
	}),
	CustomColumn({
		title: 'Is Deployed',
		mapDataToValue: (data: any) => data[COL_NAMES.isActive],
		maxWidth: 200,
		renderCell: (params: any) => {
			const { value } = params;
			const [css] = useStyletron();
			return (
				<div
					className={css({
						backgroundColor: value ? 'green' : 'red',
						height: '30px',
						width: '100%'
					})}
				/>
			);
		}
	}),
	CategoricalColumn({
		title: 'Location',
		minWidth: 150,
		mapDataToValue: (data: any) => data[COL_NAMES.location] || 'HOME_SCREEN'
	}),
	CategoricalColumn({
		title: 'CTA Type',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.ctaType]
	}),
	CategoricalColumn({
		title: 'CTA Value',
		maxWidth: 600,
		mapDataToValue: (data: any) => data[COL_NAMES.ctaValue] || EMPTY_STRING,
		type: 'string'
	}),
	CategoricalColumn({
		title: 'CTA Params GameName',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.ctaParamsGameName] || EMPTY_STRING,
		type: 'string'
	}),
	NumericalColumn({
		title: 'Image Ratio',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.imageRatio] || EMPTY_STRING
	}),
	CustomColumn({
		title: 'Image',
		minWidth: 400,
		maxWidth: 400,
		mapDataToValue: (data: any) => data[COL_NAMES.imageUrl],
		renderCell: ({ value }: { value: any }) => {
			const [css] = useStyletron();
			return (
				<a href={value} target='_blank' rel='noreferrer'>
					<img src={value} alt='' className={css({ height: '90px' })} />
				</a>
			);
		}
	}),
	NumericalColumn({
		title: 'Min App',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.minAppVersionSupported] || EMPTY_STRING
	}),
	NumericalColumn({
		title: 'Max App',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.maxAppVersionSupported] || EMPTY_STRING
	}),
	CustomColumn({
		title: 'Segments List',
		mapDataToValue: (data: any) => (data[COL_NAMES.userSpecificSegmentsList] || EMPTY_ARRAY).join(','),
		renderCell: (params: any) => params.value || ''
	}),
	CategoricalColumn({
		title: 'Segment Instruction',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.segmentInstruction] || EMPTY_STRING,
		type: 'string'
	}),
	BooleanColumn({
		title: 'Is Removed For Blocked User',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.removedForBlockedUser]
	}),
	CategoricalColumn({
		title: 'Language',
		maxWidth: 200,
		mapDataToValue: (data: any) => {
			const lang = _find(LANG_OPTIONS, (option: { id: string; label: string }) => option.id === data[COL_NAMES.language]);
			return lang ? lang.label : EMPTY_STRING;
		}
	}),
	NumericalColumn({
		title: 'Sort Order',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.sortOrder] || 0
	}),
	CustomDateColumn({
		title: 'Expires At',
		minWidth: 200,
		maxWidth: 200,
		columnName: COL_NAMES.expiresAt
	}),
	BooleanColumn({
		title: 'Is Active',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.isActive]
	})
];

export const activeFilter = [
	{
		columnKey: 'Is Active',
		filterLabel: 'Active Banners',
		filterValue: true
	}
];
